export default {"src":"/_next/static/media/whypod-icon6.8198be09.svg","height":53,"width":54};